enum PermissionType {
  READ_ONLY = "READ_ONLY",
  READ_WRITE = "READ_WRITE",
}

export default PermissionType;
